// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"bb843741","784":"33c12831"}[chunkId] + ".chunk.js";
};